import "./Main.css";
import PlayerRow from "../components/PlayerRow";

export default function Main() {
  return (
    <div className="mainContainer">
      <PlayerRow />
    </div>
  );
}
